import styled from 'styled-components';

export const ContentTitle = styled.h2`
	font-family: 'Poppins',sans-serif !important;
	font-size: 1.5em !important;
	color: #2B2932;
	font-weight: bold;
`;

export const BackofficeClientsList = styled.div`
  font-family: Poppins, Heltica, Arial, sans-serif;
  padding: 35px 27px;
  
  header {
  	display: flex;
  
	.fa.fa-bullhorn {
		color: #F3463C;
	    margin-right: 10px;
	    font-size: 15px;
	 }
  }
  
  h2 {
     margin: 0;
     padding: 0;
  }
  
  .table-list {
    background-color: #FFF;
    border-radius: 3px;
    padding: 30px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, .2);
    
    .input-txt {
      font-size: 1.4em;
    }
  }
  
  h3 {
    color: #2B2932;
    font-size: 1.5em;
  }
  
  table {
    font-size: 10px !important;
    
    td {
      font-size: 1.4em;
    }
    
    th {
      font-size: 1.2em;
    }
    
    .btn-outline-secondary {
      font-size: 1em;
      padding: 6px 25px;
      color: #707070;
      
      &:hover {
        color: #ffffff;
      }
    }
  }
`;
